<template>
  <div class="card card-rounded"
       :class="[{ 'card-with-watermark' : watermarkIcon }, cardClass]"
  >
    <template v-if="header">
      <div class="card-header bg-iute-yellow font-weight-bold text-uppercase text-center text-muted small border-0">
        {{header}}
      </div>
    </template>
    <template v-if="stripBody">
      <slot />
    </template>
    <template v-else>
      <div class="card-body" :class="bodyClass">
        <template v-if="title">
          <div class="card-title mb-3">{{ title }}</div>
        </template>
        <slot />
      </div>
    </template>
    <template v-if="watermarkIcon && state.insufficientFunds ===false">
      <icon :icon-name="watermarkIcon" icon-class="icon-watermark"></icon>
    </template>
    <template v-if="watermarkIcon && state.insufficientFunds ===true">
      <icon :icon-name="watermarkIcon" icon-class="icon-watermark" style="bottom: -2.5rem;"></icon>
    </template>
  </div>
</template>

<script>

import Icon from '@shared/components/Icon'
export default {
  components: { Icon },
  props: {
    title: String,
    header: String,
    iconName: String,
    stripBody: Boolean,
    watermarkIcon: String,
    cardClass: String,
    bodyClass: String
  }
}
</script>
